import React from 'react'
import { useTranslation } from 'react-i18next'

import ErrorBannerMdSrc from '@/assets/error-banner-md.svg'
import ErrorBannerXsSrc from '@/assets/error-banner-xs.svg'
import ErrorBannerSrc from '@/assets/error-banner.svg'
import { Button } from '@/atoms/Button'
import { Font } from '@/atoms/GenericComponents'
import { Routes } from '@/lib/routes'
import { ErrorPageBase } from '@/molecules/ErrorPageBase'
import { backgroundGray, secondaryBlack } from '@/refactor/colors'
import styled, { FontType, muiUtils } from '@/styles'

interface GeneralErrorPageProps {
	errorId: string | null
}

const StyledErrorPage = styled(ErrorPageBase)`
	overflow-x: hidden;
	min-height: 100vh;
	background-color: ${backgroundGray};
`

export const StyledButton = styled(Button)`
	${muiUtils.mobile} {
		width: 100%;
	}
`

export function GeneralErrorPage({ errorId }: GeneralErrorPageProps) {
	const { t } = useTranslation()

	const reload = () => window.location.reload()

	return (
		<React.Suspense fallback={<></>}>
			<StyledErrorPage
				title={t('Something went wrong')}
				subtitle={t('error-banner.subtitle')}
				buttons={[
					<StyledButton
						key="goToHome"
						onClick={() => {
							window.location.href = Routes.Home
						}}
						color="blueOutline"
						minWidth={160}
					>
						{t('error-banner.go-to-home')}
					</StyledButton>,
					<StyledButton key="reload" onClick={reload} color="bluePrimary" minWidth={160}>
						{t('error-banner.refresh')}
					</StyledButton>,
				]}
				pageInfoContent={
					errorId ? (
						<Font as="div" weight={700} size={12} color={secondaryBlack} family={FontType.Comfortaa}>
							{t('error-banner.error-id', { errorId })}
						</Font>
					) : null
				}
				pictureProps={{
					defaultSrc: ErrorBannerSrc,
					srcSets: { xs: ErrorBannerXsSrc, md: ErrorBannerMdSrc },
					width: '100%',
				}}
			/>
		</React.Suspense>
	)
}
